import { Situacao } from "./Situacao";

export const traduzirSituacao = (situacao:Situacao) => {
    switch(situacao) {
        case "CAPACIDADE_CARGA_OK": return ""
        case "CAPACIDADE_DE_CARGA_NAO_FOI_AVALIADA": return ""
        case "NAO_LOCALIZADO_CADASTRO_CAPACIDADE_CARGA": return "Capacidade de carga não cadastrada"
        case "CAPACIDADE_INDISPONIVEL_EXISTE_ENCAIXE_POSSIVEL_E_NOVA_DATA_PENDENTE_DE_APROVACAO_NAO_INFORMADA": 
        case "CAPACIDADE_INDISPONIVEL_NAO_EXISTE_ENCAIXE_POSSIVEL_EXISTE_ENCAIXE_CADASTRADO":
        case "CAPACIDADE_INDISPONIVEL_NAO_EXISTE_ENCAIXE_POSSIVEL_NAO_EXISTE_ENCAIXE_CADASTRADO":
            return "Capacidade de carga indisponível"
        case "CAPACIDADE_INDISPONIVEL_TIPO_FRETE_IMPOSSIVEL_PARA_CAPACIDADE_DE_CARGA":
            return "Tipo de frete não permitido"
        case "SITUACAO_DESCONHECIDA": return ""
        case "CAPACIDADE_INDISPONIVEL_EXISTE_ENCAIXE_POSSIVEL_E_NOVA_DATA_PENDENTE_DE_APROVACAO_INFORMADA_LIBERACAO_PENDENTE":
        case "CAPACIDADE_INDISPONIVEL_EXISTE_ENCAIXE_POSSIVEL_E_NOVA_DATA_PENDENTE_DE_APROVACAO_INFORMADA_LIBERACAO_APROVADA": 
            return ""
        default: return ""
    }
}